import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  state: {
    regions: null,
  },
  getters: {
    getRegionList: state => state.regions,
  },
  mutations: {
    successRegions: (state, payload) => {
      state.regions = payload;
    },
  },
  actions: {
    getRegionList: async ({ commit, getters }) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/regions/');

      commit('successRegions', result.response.result.rows);
      return result.response.result.rows;
    },

    updateRegion: async ({ commit, getters }, data) => {
      const region = {
        id: data.id,
        country: data.country,
        region1: data.region1,
        region2: data.region2,
        region3: data.region3,
        region4: data.region4,
        country_en: data.countryEn,
        region1_en: data.region1En,
        region2_en: data.region2En,
        region3_en: data.region3En,
        region4_en: data.region4En,
        region_dsc: data.regionDsc,
        img_region: data.imgRegion,
        is_checked: data.isChecked,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/regions/${region.id}`, region);
      return result;
    },

    createEmptyRegion: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/regions/');
      return result;
    },

    deleteRegion: async ({ commit, getters }, id) => {
      const result = await statusHandler.authDelete({ commit, getters }, `/api/regions/${id}`);
      return result;
    },

    deleteRegions: async ({ commit, getters }, ids) => {
      const result = await statusHandler.authPatch({ commit, getters }, '/api/regions/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/region.js